export default __webpack_public_path__ + "static/media/business1@2x.80b4d367.png";